<template>
  <div>
    <div class="form-wrap">
      <div class="form-list px-2 py-2">
        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][4]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.family_name" @change="$v.input.family_name.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.family_name}}</p>

          </div>

          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][5]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.given_name" @change="$v.input.given_name.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.given_name}}</p>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][2]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.address_1.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][6]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.address_1" @change="$v.input.address_1.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.address_1}}</p>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.address_1" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][3]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][7]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.address_2" @change="$v.input.address_2.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.address_2}}</p>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.city.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][8]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.city" @change="$v.input.city.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.city}}</p>

          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.city" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][4]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.prefecture.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][9]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.prefecture" @change="$v.input.prefecture.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.prefecture}}</p>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.prefecture" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][5]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.zip_code.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][10]"/></label>
          <div class="col-7">
            <input v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.zip_code" @change="$v.input.zip_code.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.zip_code}}</p>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.zip_code" type=""><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][6]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <!--<div class="form-group row" :class="{'has-danger': $v.input.country_name.$error}">-->
          <!--<label class="col-5 col-form-label"><trans-text i18nKey="ui[95][11]"/></label>-->
          <!--<div class="col-7">-->
            <!--<input  v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.country_name" @change="$v.input.country_name.$touch()">-->
            <!--<p v-if="isConfirm" class="form-control-static">{{input.country_name}}</p>-->
          <!--</div>-->
          <!--<p class="col-12 pl-4 my-0 form-control-feedback">-->
            <!--<input-feedback :validate-for-input="$v.input.country_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][8]"/></input-feedback>-->
          <!--</p>-->

          <!--<div class="col-12 form-hr">-->
            <!--<hr class="">-->
          <!--</div>-->
        <!--</div>-->

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.phone_nunber.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[95][12]"/></label>
          <div class="col-7">
            <input  v-if="!isConfirm" class="form-control transparent-input" type="text" v-model.trim="input.phone_nunber" @change="$v.input.phone_nunber.$touch()">
            <p v-if="isConfirm" class="form-control-static">{{input.phone_nunber}}</p>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.phone_nunber" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][9]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center" v-if="!isConfirm">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[95][13]" :adjustLangFontSizes="{}"/></button>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center" v-if="isConfirm">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="sendForm"><trans-text i18nKey="ui[95][15]" :adjustLangFontSizes="{}"/></button>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center" v-if="isConfirm">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-default" @click="toggleConfirm"><trans-text i18nKey="ui[95][16]" :adjustLangFontSizes="{}"/></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    props:["isConfirm"],
    data () {
      return {
        input: {
          family_name:null,
          given_name:null,
          address_1:null,
          address_2:null,
          city:null,
          prefecture:null,
          zip_code:null,
//          country_name:null,
          phone_nunber:null,
        }
      }
    },
    watch:{
      "input.zip_code"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.zip_code =  val
      },
      "input.phone_nunber"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.phone_nunber =  val
      },
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        address_1: {
          required
        },
        address_2: {
        },
        city: {
          required
        },
        prefecture: {
          required
        },
        zip_code: {
          required
        },
//        country_name: {
//          required
//        },
        phone_nunber: {
          required
        },
      }
    },
    created(){
    },
    methods:{
      toggleConfirm(){
        this.$emit('toggleConfirm')
      },
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('toggleConfirm')
      },
      sendForm(){
        this.$emit("sendForm",this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-group{
    font-size: .9rem;
  }

</style>



// WEBPACK FOOTER //
// PageForm.vue?d9dbac6e